<template>
  <div class="s-rule" :style="{...defaultBg.style}">
    <div class="s-topic-bg-wrap">
      <SAnimateImage :width="defaultBg.style.width" :height="defaultBg.style.height" :src="defaultBg.src" mask=""></SAnimateImage>
    </div>
    <img v-if="btnRule.src" :src="btnRule.src" :style="{...btnRule.style}" alt="" @click="ruleFun">
  </div>
</template>

<script>
import SAnimateImage from "@/components/BuilderComponents/AnimateImage/index.vue";

export default {
  name: 'SActivityRule',
  components: { SAnimateImage },
  props: {
    defaultBg: {
      type: Object,
      required: true
    },
    ruleId: {
      type: String,
      default: ''
    },
    btnRule: {
      type: Object,
      default: () => {
        return {}
      }
    },
    title: {
      type: String,
      default: ''
    },
    request: {
      type: Function
    }
  },
  inject: {
    eventBus: {
      default: null
    },
    $MainWrap: {
      default: null
    }
  },
  computed: {
    requestAPI () {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    }
  },
  data () {
    return {
    }
  },
  methods: {
    // 点击活动规则
    ruleFun () {
      this.requestAPI({
        url: '/api/news/detail',
        method: 'get',
        params: { id: this.ruleId }
      }).then((res) => {
        this.$MainWrap.openModalTip({ title: this.title, content: res.content })
      }).catch((err) => {
        this.$message.error(err.msg || '系统错误')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.s-rule{
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
}
</style>
